import axios from '@/framework/router/axios'

export const setOrderItemList = (column, asc = true) => {
  let orderItemList = []
  if (column) {
    orderItemList = [{
      asc,
      column
    }]
  }
  return orderItemList
}

const apiAccountQuery = async(postdata, column, params) => {
  let orderItemList = setOrderItemList(column)
  return axios.post('/account/query', { entity: postdata, orderItemList }, {
    params
  })
}

const apiAccountListOrgId = async(postdata, column, params) => {
  let orderItemList = setOrderItemList(column)
  return axios.post('/account/list/org-id', { entity: postdata, orderItemList }, {
    params
  })
}

const apiAcountListRoleId = async(postdata, column, params) => {
  let orderItemList = setOrderItemList(column)
  return axios.post('/account/list/role-id', { entity: postdata, orderItemList }, {
    params
  })
}

const apiOrgList = async(postdata, column) => {
  let orderItemList = setOrderItemList(column)
  return axios.post('/org/list', {
    entity: postdata, // parentPermissionSubjectId
    orderItemList
  })
}

const apiRoleList = async(postdata, column) => {
  let orderItemList = setOrderItemList(column)
  return axios.post('/role/list', {
    entity: postdata, // parentPermissionSubjectId
    orderItemList
  })
}

const apiTenantListAvailable = async() => {
  return await axios.get('/tenant/list-available')
}

// const api 1. 当前机构树api
// 当前机构层级用户

export default {
  apiAccountQuery,
  apiAccountListOrgId,
  apiAcountListRoleId,
  apiOrgList,
  apiRoleList,
  apiTenantListAvailable
}
